import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { Button, Input, Popconfirm, message } from 'antd'
import styled from 'styled-components'
import RichTextEditor from 'react-rte'
import { actions } from '../../redux/modules/templatesActions'
import { actions as itemActions } from '../../redux/modules/jobFunctions/itemActions'
import history from '../../history'
import config from '../../config'

const { API_BASE } = config

const Container = styled.div`
  padding: 25px;
`
const MarginTop = styled.div`
  margin-top: 15px;
`
const FormLabel = styled.div`
  margin-top: 10px;
`
const propTypes = {}
const { TextArea } = Input

class TemplatesJobMinute extends Component {
  constructor(props) {
    super(props)
    this.state = {
      currentKey: 'job_minute',
      currentId: +this.props.match.params.templateId,
      body: RichTextEditor.createEmptyValue()
    }
  }

  componentWillMount() {
    this.props.getTemplateById({
      templateType: this.state.currentKey,
      templateId: this.state.currentId
    })
    this.props.getAllItems()
  }

  componentDidUpdate(prevProps) {
    if (this.props.templatesActions && this.props.templatesActions.loadedTemplate) {
      if (
        this.props.templatesActions.loadedTemplate !== prevProps.templatesActions.loadedTemplate
      ) {
        const loadedTemplate = this.props.templatesActions.loadedTemplate.data[0]
        if (loadedTemplate) {
          this.setState({
            templateName: loadedTemplate.name,
            templateDescription: loadedTemplate.description,
            attendees: loadedTemplate.attendees,
            subject: loadedTemplate.subject,
            body: RichTextEditor.createValueFromString(loadedTemplate.body, 'html')
          })
        }
      }
    }
  }

  handleInputChange = (value, input) => {
    this.setState({ [input]: value })
  }

  handleCreate = () => {
    const { templateName, templateDescription, attendees, subject, body, currentId } = this.state
    const data = {
      attendees: attendees,
      subject: subject,
      body: body.toString('html'),
      description: templateDescription,
      name: templateName,
      estimate_template_id: currentId
    }
    if (currentId === 0) {
      this.props.createTemplate({
        templateType: 'job_minute',
        content: data,
        userId: this.props.authentication.user.userId
      })
    } else {
      this.props.saveTemplate({
        templateId: this.state.currentId,
        templateType: 'job_minute',
        content: data,
        userId: this.props.authentication.user.userId
      })
    }

    message.success('Changes saved.')
    this.setState({ contentData: null, currentId: 0, modalVisible: false })
  }

  confirmDelete = () => {
    this.props.deleteTemplate({
      templateId: this.state.currentId,
      templateType: 'job_minute'
    })

    message.success('Record deleted.')
    this.setState({
      contentData: null,
      currentId: 0,
      modalVisible: false
    })
  }

  render() {
    return (
      <Container>
        <h2>Job Minute Template</h2>
        <div className="row">
          <div className="col-md-12">
            <div>Template</div>
            <Input
              value={this.state.templateName}
              onChange={event => this.handleInputChange(event.target.value, 'templateName')}
            />
          </div>
        </div>
        <div>Description</div>
        <TextArea
          placeholder="Type in description..."
          rows={4}
          onChange={event => this.handleInputChange(event.target.value, 'templateDescription')}
          value={this.state.templateDescription}
        />
        <div>Attendees</div>
        <Input
          placeholder="Type in the attendees..."
          onChange={event => this.handleInputChange(event.target.value, 'attendees')}
          value={this.state.attendees}
        />
        <div>Subject</div>
        <Input
          placeholder="Type in the title..."
          onChange={event => this.handleInputChange(event.target.value, 'subject')}
          value={this.state.subject}
        />
        <FormLabel>Body</FormLabel>
        <RichTextEditor
          value={this.state.body}
          onChange={event => this.handleInputChange(event, 'body')}
        />
        <div className="row">
          <div className="col-md-12">
            <MarginTop>
              {this.state.currentId > 0 && (
                <Fragment>
                  <Popconfirm
                    title="Are you sure you want to delete this record?"
                    onConfirm={this.confirmDelete}
                    onCancel={this.cancelDelete}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button type="danger" icon="delete" className="mr-2" />
                  </Popconfirm>
                  <a
                    href={`${API_BASE}/api/templates/job_minute/id/${this.state.currentId}/print`}
                    target="_blank"
                  >
                    <Button icon="printer" className="mr-2" />
                  </a>
                </Fragment>
              )}
            </MarginTop>
          </div>
        </div>
        <MarginTop>
          <Button onClick={() => history.goBack()}>Cancel</Button>{' '}
          <Button type="primary" onClick={() => this.handleCreate()}>
            {this.state.currentId === 0 && <span>Create Template</span>}
            {this.state.currentId > 0 && <span>Save Changes</span>}
          </Button>
        </MarginTop>
      </Container>
    )
  }
}

const mapStateToProps = ({ templatesActions, itemActions, authentication }, ownProps) => ({
  templatesActions,
  itemActions,
  authentication
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(Object.assign({}, actions, itemActions), dispatch)
})

TemplatesJobMinute.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TemplatesJobMinute))



// WEBPACK FOOTER //
// ./src/containers/templates/jobMinuteTemplate.js